export const portalEn: Record<string, string> = {
  'portal': 'Portal',
  'back_to_help': 'Back to Help',

  // Help Categories
  'first_fitting': 'First Fitting',
  'undergarments_foundation': 'Undergarments & Foundation',
  'transport_care': 'Transport & Care',
  'wedding_day_preparation': 'Wedding Day Preparation',
  'alterations_process': 'Alterations Process',
  'general_faq': 'General FAQ',

  // Help page
  'help_tips': 'Help & Tips',
  'help_description': 'Find answers to common questions and get helpful tips for your bridal journey.',
  'search_articles': 'Search articles...',
  'all_categories': 'All Categories',
  'article_found': 'article found',
  'articles_found': 'articles found',
  'no_articles_found': 'No articles found',
  'adjust_search': 'Try adjusting your search terms or category filter.',
  'no_articles_available': 'No articles are currently available.',
  'read_full_article': 'Read full article',

  // Wishlist
  'my_wishlist': 'My Wishlist',
  'wishlist_coming_soon': 'Coming Soon',
  'wishlist_description': 'Collect and organize your dream wedding inspiration in one beautiful gallery',
  'loading_wishlist': 'Loading your wishlist...',
  'dresses': 'Dresses',
  'veils': 'Veils',
  'shoes': 'Shoes',
  'jewelry': 'Jewelry',
  'lookbook': 'Lookbook',
  'dress': 'Dress',
  'veil': 'Veil',
  'add_item': 'Add Item',
  'pinterest': 'Pinterest',
  'in_store': 'In-Store',
  'add_to_wishlist': 'Add to Wishlist',
  'title_optional': 'Title (Optional)',
  'title_placeholder': 'e.g., Elegant A-Line Gown',
  'image_url_upload': 'Image URL or Upload',
  'image_url_placeholder': 'Paste Pinterest link or upload photo',
  'add_to_wishlist_btn': 'Add to Wishlist',
  'share_your_wishlist': 'Share Your Wishlist',
  'share_description': 'Create a shareable link to your wishlist that friends and family can view.',
  'create_share_link': 'Create Share Link',
  'no_items_yet': 'No {category} items yet',
  'no_items_all': 'No items yet',
  'wishlist_empty_description': 'Start building your dream wedding collection by adding inspiration photos and links.',
  'add_first_item': 'Add Your First Item',
  'wishlist_preview_notice': 'This is a preview of the upcoming Wishlist & Lookbook feature. All functionality including masonry gallery, category filtering, sharing, and real-time staff additions will be enabled soon!',

  // Wishlist Categories
  'wishlist_dress': 'Dress',
  'wishlist_veil': 'Veil',
  'wishlist_shoes': 'Shoes',
  'wishlist_jewelry': 'Jewelry',
  'wishlist_other': 'Other',

  // Wishlist Sources
  'source_instore': 'In-Store',
  'source_pinterest': 'Pinterest',
  'source_lookbook': 'Lookbook',
  'source_upload': 'Upload',

  // Loyalty
  'loyalty_referrals': 'Loyalty & Referrals',
  'earn_rewards_referring': 'Earn rewards by referring friends to their dream dress experience',
  'loyalty_progress': 'Loyalty Progress',
  'refer_friends': 'Refer {target} friends to unlock your reward',
  'progress': 'Progress',
  'referrals': 'referrals',
  'reward_veil_cleaning': 'Reward: Free veil cleaning service',
  'your_referral_code': 'Your Referral Code',
  'share_code_friends': 'Share this code with friends for exclusive discounts',
  'tap_reveal_code': 'Tap to reveal code',
  'preview_mode': '(Preview mode)',
  'code_hide_15s': 'Code will hide in 15 seconds',
  'reveal_code': 'Reveal Code',
  'terms_conditions': 'Terms & Conditions',
  'accept_terms': 'I have read and accept the terms and conditions (Preview mode)',
  'recent_referrals': 'Recent Referrals',
  'track_referrals': 'Track your successful referrals',
  'no_referrals_yet': 'No referrals yet',
  'start_sharing': 'Start sharing to earn rewards!',
  'loyalty_preview_notice': "This is a preview of the upcoming Loyalty & Referrals feature. All functionality will be enabled soon!",
  'loading_rewards': 'Loading your rewards...',
  'full_screen_inspiration': 'Full screen inspiration',
  'inspiration': 'inspiration',
  'coming_soon_badge': 'Coming Soon',
  'get_discount_appointment': 'Get 10% off on your bridal appointment!',
  'use_referral_code': 'Use my referral code: {code}',
  'share_cancelled': 'Sharing cancelled or failed',
  'copy_referral_fallback': 'Use my referral code: {code} at {url}',
  'referral_valid_new_customers': 'Referral codes are valid for new customers only.',
  'friends_book_deposit': 'Friends must book and pay a deposit to qualify as a successful referral.',
  'email_one_use_only': 'Each email address can use a referral code only once.',
  'rewards_after_booking': 'Rewards are earned after successful friend bookings are confirmed.',
  'points_expire_inactivity': 'Loyalty points expire after 12 months of inactivity.',
  'rewards_no_cash_exchange': 'Rewards cannot be exchanged for cash value.',
  'terms_subject_change': 'Terms subject to change with notice.',

  // Portal payments
  'portal.payments.payButton': 'Pay Balance',
  'portal.payments.amountLabel': 'Amount',
  'portal.payments.balanceRemaining': 'Balance Remaining',
  'portal.payments.successToast': 'Payment Successful',
  'portal.payments.errorOverLimit': 'Amount exceeds remaining balance',
  'portal.requests.title': 'Payment Requests',
  'portal.requests.payNow': 'Pay Now',
  'portal.requests.status.pending': 'Pending',
  'portal.requests.status.sent': 'Sent',
  'portal.requests.status.paid': 'Paid',
  'portal.requests.status.cancelled': 'Cancelled',
  'portal.requests.status.partiallyPaid': 'Partially Paid',
  'portal.requests.payRemaining': 'Pay Remaining',
  'portal.requests.noneOpen': 'No open payment requests at this time.',
  'portal.requests.completeFirst': 'Complete payment #{number} first',
  'portal.progress.amountPaid': 'Amount Paid',
  'portal.progress.progress': 'Progress',
  'portal.progress.remaining': 'Remaining',

  // Portal pay modal
  'portal.pay.modal.title': 'Complete Payment',
  'portal.pay.context.order': 'Order',
  'portal.pay.context.invoice': 'Invoice',
  'portal.pay.context.request': 'Payment Request',
  'portal.pay.outstanding': 'Outstanding',
  'portal.pay.minimum': 'Minimum',
  'portal.pay.submit': 'Continue to Payment',
  'portal.pay.success': 'Payment successful',
  'portal.pay.amount.label': 'Payment amount',
  'portal.pay.amount.minError': 'Amount must be at least',
  'portal.pay.amount.maxError': 'and no more than',
  'portal.pay.amount.payLabel': 'Pay €{amount}',
  'portal.pay.quick.min': 'Minimum',
  'portal.pay.quick.half': '50%',
  'portal.pay.quick.remaining': 'Remaining',
  'portal.pay.quick.minAria': 'Set amount to minimum: €{amount}',
  'portal.pay.quick.halfAria': 'Set amount to 50%: €{amount}',
  'portal.pay.quick.remainingAria': 'Set amount to remaining: €{amount}',
  'portal.pay.loading.form': 'Loading payment form...',

  // Portal pay errors
  'portal.pay.error.title': 'Payment error',
  'portal.pay.error.refresh': 'Refresh page to try again',
  'portal.pay.error.configMissing': 'Payment configuration missing',
  'portal.pay.error.configInvalid': 'Invalid payment configuration',
  'portal.pay.error.initFailed': 'Failed to initialize payment system',
  'portal.pay.error.loadFailed': 'Failed to load payment system',
  'portal.pay.error.unavailable': 'Payment system unavailable',
  'portal.pay.error.notReady': 'Payment system not ready. Please wait and try again.',
  'portal.pay.error.formNotReady': 'Payment form not ready. Please wait for the form to load completely.',
  'portal.pay.error.formLoadFailed': 'Payment form failed to load. Please refresh and try again.',
  'portal.pay.error.cardDeclined': 'Your card was declined. Please try a different payment method.',
  'portal.pay.error.invalidNumber': 'Please check your card number and try again.',
  'portal.pay.error.invalidExpiry': 'Please check your card expiry date and try again.',
  'portal.pay.error.invalidCvc': 'Please check your card security code and try again.',
  'portal.pay.error.failed': 'Payment failed',
  'portal.pay.error.generic': 'Payment error',

  // Portal pay intent messages
  'portal.pay.intent.setupErrorTitle': 'Payment setup error',
  'portal.pay.intent.unavailable': 'Payment setup is temporarily unavailable. Please try again in a few moments.',
  'portal.pay.intent.unavailableShort': 'Payment service is temporarily unavailable. Please try again shortly.',
  'portal.pay.intent.timeout': 'Payment setup is taking longer than expected. Please try again.',
  'portal.pay.intent.network': 'Network connection issue. Please check your connection and try again.',
  'portal.pay.intent.concurrent': 'Another payment was processed while you were preparing this payment. Please refresh the page and try again.',
  'portal.pay.intent.alreadyPaid': 'This payment request has already been fully paid.',
  'portal.pay.intent.invalidResponse': 'Invalid payment response from server',
  'portal.pay.intent.configIncomplete': 'Payment configuration incomplete',
  'portal.pay.intent.setupFailed': 'Payment setup failed. Please try again.',
  'portal.pay.intent.setupTimeout': 'Payment setup timed out. Please try again.',
  'portal.pay.intent.networkError': 'Network error. Please check your connection and try again.',

  // Portal pay button and assistive text
  'portal.pay.button.preparing': 'Preparing...',
  'portal.pay.button.retrying': 'Retrying...',
  'portal.pay.button.tryAgain': 'Try again',
  'portal.pay.button.processing': 'Processing...',
  'portal.pay.button.loading': 'Loading payment form...',
  'portal.pay.sr.processing': 'Payment is being processed, please wait',
  'portal.pay.sr.loading': 'Payment form is loading, please wait',
  'portal.pay.sr.disabledReason': 'Button disabled because amount is outside valid range',
  'portal.offline.checkConnectionAlert': 'Please check your internet connection and try again',
  'portal.offline.title': "You're currently offline",
  'portal.offline.description1': "Don't worry - some features are still available while you're offline.",
  'portal.offline.description2': 'Your bridal journey continues when you reconnect!',
  'portal.offline.goToPortal': 'Go to Portal',
  'portal.offline.checkConnection': 'Check Connection',
  'portal.offline.comingSoon': 'Offline features coming soon:',
  'portal.offline.featureAppointments': 'View cached appointments',
  'portal.offline.featurePhotos': 'Browse saved photos',
  'portal.offline.featureHelp': 'Read help articles',
};
